import type { MigrationItem } from '../../components/DeleteEntityModals/components/ListItemCard';

const hasValidUser = (migrationValue: MigrationItem): boolean =>
  migrationValue.targetUserId !== null;

export default hasValidUser;
